import { createSlice } from '@reduxjs/toolkit';

const getInitialUiState = () => {
  try {
    const savedWishlist = localStorage.getItem('wishlist');
    return {
      isCartOpen: false,
      wishlist: savedWishlist ? JSON.parse(savedWishlist) : [],
      orderState: {
        isValid: false,
        orderId: null,
        timestamp: null
      }
    };
  } catch (error) {
    console.error("Could not load wishlist from local storage", error);
    return {
      isCartOpen: false,
      wishlist: [],
      orderState: {
        isValid: false,
        orderId: null,
        timestamp: null
      }
    };
  }
};

const saveWishlistState = (wishlist) => {
  try {
    localStorage.setItem('wishlist', JSON.stringify(wishlist));
  } catch (error) {
    console.error("Could not save wishlist to local storage", error);
  }
};

const uiSlice = createSlice({
  name: 'ui',
  initialState: getInitialUiState(),
  reducers: {
    toggleCart: (state, action) => {
      state.isCartOpen = action.payload ?? !state.isCartOpen;
    },
    addToWishlist: (state, action) => {
      const id = action.payload;
      if (!state.wishlist.includes(id)) {
        state.wishlist.push(id);
        saveWishlistState(state.wishlist);
      }
    },
    removeFromWishlist: (state, action) => {
      const id = action.payload;
      state.wishlist = state.wishlist.filter(x => x !== id);
      saveWishlistState(state.wishlist);
    },
    setOrderState: (state, action) => {
      state.orderState = {
        isValid: true,
        orderId: action.payload.orderId,
        timestamp: Date.now()
      };
    },
    clearOrderState: (state) => {
      state.orderState = {
        isValid: false,
        orderId: null,
        timestamp: null
      };
    },
  }
});

export const { toggleCart, addToWishlist, removeFromWishlist, setOrderState, clearOrderState } = uiSlice.actions;
export default uiSlice.reducer; 